import { inject } from 'mobx-react';
import * as React from 'react';

import { CurrentHotelStore } from 'stores/current-hotel-store';

import { UitkSpacing } from 'uitk-react-spacing';

import { SimilarHotels } from 'components/infosite/similar-hotels/similar-hotels';

interface SimilarHotelsWrapperProps {
  currentHotel?: CurrentHotelStore;
}

export const SimilarHotelsWrapper: React.FunctionComponent<SimilarHotelsWrapperProps> = inject('currentHotel')(props => {
  const { defaultedDates, similarHotels, similarHotelsDateless } = props.currentHotel || {};

  if (!(similarHotels || similarHotelsDateless)) {
    return null;
  }

  return (
    <UitkSpacing margin={{ block: 'six' }}>
      <div data-stid="meso-similar-properties-carousel">
        <SimilarHotels
          similarHotels={defaultedDates ? (similarHotelsDateless as any) : (similarHotels as any)}
          isDatelessPdp={defaultedDates}
        />
      </div>
    </UitkSpacing>
  );
});
